<script setup lang="ts">
import Logo from './Logo.vue';

const props = defineProps<{
	isLight?: boolean;
}>();
</script>

<template>
	<div class="entry-card" :class="{ 'entry-card--light': props.isLight }">
		<div class="entry-card__header">
			<Logo />
		</div>
		<div class="entry-card__body">
			<slot />
		</div>
	</div>
</template>
